import {formatDate} from '@angular/common';
import {Pipe, PipeTransform, inject} from '@angular/core';
import {LocaleService} from '../../translation/services/locale.service';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe implements PipeTransform {
  private readonly localeService = inject(LocaleService);

  transform(
    value: string | number | Date | null | undefined,
    format = 'mediumDate',
    timezone?: string,
  ): string | null {
    if (value === null || value === undefined) {
      return null;
    }

    return formatDate(value, format, this.localeService.userLanguage, timezone);
  }
}
